import { createDefaultQueryClient } from "@marekl/adminer/api";

// notifyMutationErrors defaults to false in the lib, which meant every
// `catch { /* toast handled by mutation defaults */ }` in this app was a
// silent no-op — a failed removal left the dialog open with no explanation.
// Mutations that surface their own errors in a form opt out per call with
// meta.suppressErrorToast.
export const queryClient = createDefaultQueryClient({ notifyMutationErrors: true });
